// Helper component for displaying individual performance metrics
import React from "react";

interface PerformanceMetricItemProps {
    label: string;
    value: string | number | null | undefined;
    unit?: string;
    className?: string;
}

export const PerformanceMetricItem: React.FC<PerformanceMetricItemProps> = ({label, value, unit, className}) => (
    <div className={`bg-slate-800 p-4 rounded-lg shadow ${className}`}>
        <div className="text-sm text-slate-400 mb-1">{label}</div>
        <div className="text-2xl font-bold text-white">
            {value !== null && value !== undefined ? value : 'N/A'}{unit && (value !== null && value !== undefined) ?
            <span className="text-lg ml-1">{unit}</span> : ''}
        </div>
    </div>
);
